import { Topbar } from "../../components/organisms/Topbar"
import { TENANTS } from "../../constants"
import { updateLocalStorageLastPathNameVisited } from "../../core/service/BusinessLogicService"
import { isPdiRetailTenant, loc } from "../../core/utils"
import { PackServiceContext } from "../../digital-journey/ServicePage/context/PackServiceContext"
import { withSecuredPage } from "../../digital-journey/hoc/withSecuredPage"
import { withTunnelDataContext } from "../../digital-journey/hoc/withTunnelDataContext"
import useLocalStorageSimulationForm from "../simulation/hooks/useLocalStorageSimulationForm"
import "./styles.css"
import React, { useContext } from "react"
import { Col, Container, Row } from "react-bootstrap"

const HomePage = ({ tunnelData, onSetStep, history }) => {
  const { resetPackContext } = useContext(PackServiceContext)

  const { remove: removeLocalStorageSimulationForm } = useLocalStorageSimulationForm()
  updateLocalStorageLastPathNameVisited()

  function goToNewSimulation() {
    resetPackContext()
    removeLocalStorageSimulationForm()
    updateLocalStorageLastPathNameVisited("/simulation")
    history.push("/simulation")
  }

  return (
    <Container fluid className="home-page">
      <Topbar displayToggleButton={false} tunnelData={tunnelData} history={history} />
      <Row className="justify-content-center" style={{ paddingTop: "30px" }}>
        <Col sm={12}>
          <div className="text-center margin-bottom-32 margin-top-40" />
        </Col>
        <Col onClick={goToNewSimulation} className="text-center hard-shadow-white-block m-2" md={4} sm={12} lg={3}>
          <i className="fal fa-file" />
          <h3>{loc("home_button_new")}</h3>
          <p>{loc("home_button_new_description")}</p>
        </Col>
        {!isPdiRetailTenant(tunnelData.tenant) && (
          <Col
            onClick={() => onSetStep("de")}
            className="text-center hard-shadow-white-block m-2"
            md={4}
            sm={12}
            lg={3}
          >
            <i className="fal fa-clone" />
            <h3>{loc("home_button_takeover")}</h3>
            <p>{loc("home_button_takeover_description")}</p>
          </Col>
        )}
        {tunnelData?.tenant === TENANTS.RETAIL_IT && (
          <Col className="text-center hard-shadow-white-block m-2" md={4} sm={12} lg={3}>
            <a
              href="https://www.personalrenting.com/calcolo-penali/"
              target={"_blank"}
              className="text-decoration-none"
            >
              <i className="fal fa-calculator" />
              <h3>{loc("home_button_penalty_simulation")}</h3>
            </a>
          </Col>
        )}
      </Row>

      <Row className="justify-content-center">
        <Col
          onClick={!isPdiRetailTenant(tunnelData.tenant) ? () => onSetStep("de") : undefined}
          className="text-center hard-shadow-white-block m-2"
          md={4}
          sm={12}
          lg={3}
        >
          <i className="fal fa-sync-alt" />
          <h3>{loc("home_button_renewal")}</h3>
          <p>{loc("home_button_renewal_description")}</p>
        </Col>
        <Col
          onClick={() => {
            history.push("resume-order")
            updateLocalStorageLastPathNameVisited()
          }}
          className="text-center hard-shadow-white-block m-2"
          md={4}
          sm={12}
          lg={3}
        >
          <i className="fal fa-folder-open" />
          <h3>{loc("home_button_continue_order")}</h3>
          <p>{loc("home_button_continue_order_description")}</p>
        </Col>
        <Col
          onClick={() => window.open(tunnelData.glsURL, "_blank", "noopener noreferrer")}
          className="text-center hard-shadow-white-block m-2"
          md={4}
          sm={12}
          lg={3}
        >
          <i className="fal fa-folder" />
          <h3>{loc("home_button_after_sales")}</h3>
          <p>{loc("home_button_after_sales_description")}</p>
        </Col>
      </Row>
    </Container>
  )
}

export default withSecuredPage(withTunnelDataContext(HomePage))
